import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { AlertService } from '../../shared-services/services/alert.service';
import { DemoService } from '../../shared-services/services/demo.service';

@Component({
    selector: 'app-demo',
    templateUrl: './demo.component.html'
})
export class DemoComponent implements OnInit {

    constructor(private demoService: DemoService, private alertService: AlertService) { }

    identityJson: Observable<any> = null;

    ngOnInit() {
    }

    callApi() {
        this.demoService.getIdentity().subscribe(
            data => {
                this.identityJson = data;
            }, error => {
                this.alertService.error(error.message || 'Failed to get identity data.');
            }
        );
    }
}
